/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Dirs_Pagination_Page_CountInputs */

const es_settings_dirs_pagination_page_count = /** @type {(inputs: Settings_Dirs_Pagination_Page_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} carpeta(s) en esta página`)
};

const en_settings_dirs_pagination_page_count = /** @type {(inputs: Settings_Dirs_Pagination_Page_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} directory(ies) on this page`)
};

/**
* | output |
* | --- |
* | "{count} directory(ies) on this page" |
*
* @param {Settings_Dirs_Pagination_Page_CountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_pagination_page_count = /** @type {((inputs: Settings_Dirs_Pagination_Page_CountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Pagination_Page_CountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_pagination_page_count(inputs)
	return en_settings_dirs_pagination_page_count(inputs)
});
export { settings_dirs_pagination_page_count as "settings.dirs.pagination.page_count" }